import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const THUMBNAIL_SIZE = 56;

const REMOVE_BUTTON_SIZE = 16;

const SCRIM_BLUR = 'blur(2px)';

const SCRIM_OPACITY = 0.25;

const REMOVE_BUTTON_HOVER_OPACITY = 0.45;

export const useRachelAttachmentThumbnailStyles = makeStyles()((theme) => ({
  thumbnail: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    flex: 'none',
    boxSizing: 'border-box',
    width: THUMBNAIL_SIZE,
    height: THUMBNAIL_SIZE,
    padding: 1,
    borderRadius: theme.shape.borderRadiusLg,
    border: `0.5px solid ${alpha(theme.palette.common.black, 0.1)}`,
    backgroundColor: theme.palette.action.selected,
    overflow: 'hidden',
  },
  image: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: theme.shape.borderRadiusLg,
    pointerEvents: 'none',
  },
  scrim: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: alpha(theme.palette.common.black, SCRIM_OPACITY),
    backdropFilter: SCRIM_BLUR,
    color: theme.palette.common.white,
    pointerEvents: 'none',
  },
  removeButton: {
    '&.MuiIconButton-root': {
      position: 'relative',
      flex: 'none',
      width: REMOVE_BUTTON_SIZE,
      height: REMOVE_BUTTON_SIZE,
      padding: 0,
      color: theme.palette.common.white,
      backgroundColor: alpha(theme.palette.common.black, SCRIM_OPACITY),
      backdropFilter: SCRIM_BLUR,
      '&:hover': {
        backgroundColor: alpha(theme.palette.common.black, REMOVE_BUTTON_HOVER_OPACITY),
      },
    },
  },
}));
